<template>
  <div class="notification-form flex-grow-1 d-flex flex-column">
    <NotificationForm :notification="notification" @submit="onSubmit($event)" />
  </div>
</template>

<script>
  import NotificationForm from './NotificationForm';
  import NotificationService from '../services/notification.service';
  export default {
    name: 'NotificationAdd',
    components: {
      NotificationForm
    },
    data() {
      return {
        notification: {
          contact_group_id: null,
          url_id: null,
          notification_type: null
        }
      };
    },
    methods: {
      async onSubmit(event) {
        try {
          await NotificationService.create(event);
          this.$router.push('/notification/list');
          this.$showSuccessMessage('Added Notification!');
        } catch (error) {
          this.$showMultiErrorMessage(error.messages);
        }
      }
    }
  };
</script>

<style lang="scss" scoped></style>
